<div class="pricelist-container">
    <div class="speciality-pricelist-container">
        <div [ngStyle]="{ width: '100%', 'align-items': 'center' }" class="title-container-pricelist">
            <div class="title">
                <div class="choose-container">
                    <div class="choose-map">
                        <div class="choose">
                            <h1>Árlista</h1>
                        </div>
                        <div class="choose">
                            <h3>Átlátható, korrekt díjszabás</h3>
                        </div>
                        <div class="choose">
                            <p>
                                Minden kezelésünk aktuális költségét megtalálja az alábbi listában! Rendelőnkben van lehetősége
                                bankkártyával vagy egészségkártyával is fizetni!
                            </p>
                        </div>
                        <div class="choose">
                            <button routerLink="/healthfund" target="_blank">EGÉSZSÉGPÉNZTÁRI PARTNEREINK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="speciality">
            <div class="icons">
                <div class="icon">
                    <mat-icon *ngIf="!showExamination" (click)="showExaminationElement()">add_circle</mat-icon>
                    <mat-icon *ngIf="showExamination" (click)="showExaminationElement()">remove_circle_outline</mat-icon>
                </div>
            </div>
            <div class="spec">
                <div *ngFor="let speciality of specialities; let i = index" class="speciality-element">
                    <div class="name-container">
                        <div (click)="chooseOneSpeciality(speciality)" class="name">
                            <p>
                                <b [ngStyle]="{ 'font-size': '18px' }">{{ speciality.name! | uppercase }}</b>
                            </p>
                        </div>
                        <div *ngIf="speciality.hasSpecialityChosen && speciality.isVisible" class="exam">
                            <div
                                [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#f2f2f2' }"
                                class="examination-container"
                                *ngFor="let examination of speciality.examinationList; let i = index"
                            >
                                <div class="examination">
                                    <div class="examination-name">
                                        <span>{{ examination.name }}</span>
                                    </div>
                                    <div *ngIf="examination.price" class="examination-price">
                                        <span>{{ examination.price | currency : 'Ft' : 'symbol' : '1.0-0' }}</span>
                                    </div>
                                    <div *ngIf="!examination.price" class="examination-price">
                                        <span
                                            >{{ examination.minPrice | currency : 'Ft' : 'symbol' : '1.0-0' }} -
                                            {{ examination.maxPrice | currency : 'Ft' : 'symbol' : '1.0-0' }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="showExamination" class="exam">
                            <div
                                [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#f2f2f2' }"
                                class="examination-container"
                                *ngFor="let examination of speciality.examinationList; let i = index"
                            >
                                <div class="examination">
                                    <div class="examination-name">
                                        <span>{{ examination.name }}</span>
                                    </div>
                                    <div class="examination-price">
                                        <span>{{ examination.price | currency : 'Ft' : 'symbol' : '1.0-0' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
